exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".customSMS {\n    height : 100px;\n}\n\n.errorMessage {\n    color: red;\n}\n\n.reports {\n  width: 100%;\n}\n\n.reports th {\n  text-align: center;\n}\n\n.no-wrap {\n  white-space: nowrap;\n}\n\n.form-type {\n  margin-left: 10px;\n}\n", ""]);

// exports
